import { SxStyleFunc, SxStyle } from '@aibees/shared/theme';

export const content: SxStyleFunc<boolean | undefined> = (
  displaySearchTable
) => ({
  background: displaySearchTable ? 'initial' : (p) => p.palette.common.white,
});

export const searchBar: SxStyle = {
  background: (p) => p.palette.grey[200],
  height: '100%',
  pt: (p) => p.spacing(10),
};
